/** Iconos inline para las tarjetas del hub principal. */
export const HUB_ICON_SALAS = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
  <ellipse cx="12" cy="12" rx="4" ry="9" stroke="currentColor" stroke-width="1.5"/>
  <path d="M3 12h18" stroke="currentColor" stroke-width="1.5"/>
  <path d="M5 7.5h14M5 16.5h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`.trim();

export const HUB_ICON_LOCAL = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <rect x="4" y="8" width="7" height="10" rx="2.5" stroke="currentColor" stroke-width="1.5"/>
  <rect x="13" y="8" width="7" height="10" rx="2.5" stroke="currentColor" stroke-width="1.5"/>
  <circle cx="7.5" cy="12.5" r="1.5" fill="currentColor"/>
  <circle cx="16.5" cy="12.5" r="1.5" fill="currentColor"/>
  <path d="M8 8V6.5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`.trim();

/** Histórico: un gráfico de barras con una línea de tendencia. */
export const HUB_ICON_HISTORY = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M4 19h16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <rect x="5.5" y="12" width="3.5" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
  <rect x="10.5" y="8" width="3.5" height="11" rx="1" stroke="currentColor" stroke-width="1.5"/>
  <rect x="15.5" y="14" width="3.5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
  <path d="M5 8.5 9 5.5l4 2 5-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.55"/>
</svg>
`.trim();

/** Mundial: una copa con el mundo dentro. */
export const HUB_ICON_WORLD = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M7 4h10v4.5a5 5 0 0 1-10 0V4Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  <path d="M7 6H4.5v1.2A3 3 0 0 0 7.2 10M17 6h2.5v1.2A3 3 0 0 1 16.8 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M12 13.5V17M8.5 20h7M9.5 17h5v3h-5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  <circle cx="12" cy="7.6" r="2" stroke="currentColor" stroke-width="1.1" opacity="0.7"/>
</svg>
`.trim();
